if (!customElements.get('product-media-dots')) {
  customElements.define(
    'product-media-dots',
    class ProductMediaDots extends HTMLElement {
      constructor() {
        super();

        this.gallery = document.getElementById(this.dataset.dotsFor);
        if (!this.gallery) return;

        this.list = this.gallery.querySelector('[id^="Slider-"]');
        if (!this.list) return;

        this.slides = Array.from(this.list.querySelectorAll(':scope > .slider__slide'));
        if (this.slides.length < 2) return;

        this.slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product__media-dot';
          dot.setAttribute('aria-label', `${index + 1} / ${this.slides.length}`);
          if (index === 0) dot.classList.add('product__media-dot--active');
          dot.addEventListener('click', () => {
            slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
          this.appendChild(dot);
        });

        this.dots = Array.from(this.children);

        // Tracks the currently-centered slide directly (distance from the
        // scroll container's own center), not IntersectionObserver: with
        // multiple thresholds, a fast swipe can report two slides'
        // crossing events in separate batches, each judged only against
        // itself — the outgoing slide's fading ratio could still "win" a
        // batch that never saw the incoming slide's rising one, and the
        // dot skipped or lagged a slide behind. Measuring every slide's
        // actual position on every scroll tick has no such ordering
        // ambiguity — whichever slide is geometrically closest to center
        // right now is unambiguously the active one.
        this.updateActiveDot = () => {
          const containerCenter = this.list.getBoundingClientRect().left + this.list.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Infinity;
          this.slides.forEach((slide, index) => {
            const rect = slide.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - containerCenter);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          this.dots.forEach((dot, index) => {
            dot.classList.toggle('product__media-dot--active', index === closestIndex);
          });
        };

        let rafId = null;
        this.list.addEventListener(
          'scroll',
          () => {
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
              rafId = null;
              this.updateActiveDot();
            });
          },
          { passive: true }
        );
      }
    }
  );
}
